/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigSearchRequestModel } from '../../models/config-search-request-model';
import { FormSearchResultModel } from '../../models/form-search-result-model';

export interface FormsSearchPost$Params {
  isTemplate?: boolean;
      body?: ConfigSearchRequestModel
}

export function formsSearchPost(http: HttpClient, rootUrl: string, params?: FormsSearchPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<FormSearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, formsSearchPost.PATH, 'post');
  if (params) {
    rb.query('isTemplate', params.isTemplate, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<FormSearchResultModel>>;
    })
  );
}

formsSearchPost.PATH = '/Forms/Search';
